<div class="status-cell d-flex justify-content-between">
  <span class="bullet" [ngClass]="css">{{name}}</span>
</div>
